var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card note-wrap private-attach-wrap"},[_c('div',{staticClass:"header"},[_c('div',{staticClass:"meta"},[_c('div',{staticClass:"private-attach-grid"},_vm._l((_vm.privateAttachments),function(attachment){return _c('all-bubble',{key:attachment.id,attrs:{"file":attachment}})}),1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }